import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { logoutUser } from 'actions/user';

import Loading from 'components/Loading';

import AccountComponent from './AccountComponent';
import ChangeUsernameModal from './components/ChangeUsernameModal';
import DeactivateAccountModal from './components/DeactivateAccountModal';
import ForgottenPasswordResetModal from './components/ForgottenPasswordResetModal';
import PasswordResetModal from './components/PasswordResetModal';

import PasswordResetRequestModal from './components/PasswordResetRequestModal';

class AccountContainer extends Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    hash: undefined,
    token: null,
    isChangeUsernameModalOpen: false,
    isDeactivateAccountModalOpen: false,
    isForgottenPasswordResetModalOpen: false,
    isPasswordResetModalOpen: false,
    isPasswordResetRequestModalOpen: false,
  };

  /**
   * Component Did Mount
   * @return {undefined}
   */
  componentDidMount = () => {
    const { location: { hash } } = this.props;
    const token = this.getQueryVariable('token');

    this.setState({ hash });

    if (token) {
      this.setState({
        token,
        isForgottenPasswordResetModalOpen: true,
      });
    } else if (!this.props.user.loggedIn) {
      this.props.history.push("/login");
    }

  };

  /**
   * Get query by variable
   * @param  {String} variable
   * @return {String}
   */
  getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split('&');

    for (let i = 0; i < vars.length; i += 1) {
      const pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return undefined;
  };

  handleDismissChangeUsernameModal = () => {
    this.setState({ isChangeUsernameModalOpen: false });
  };

  handleDismissDeactivateAccountModal = () => {
    this.setState({ isDeactivateAccountModalOpen: false });
  };

  handleDismissForgottenPasswordResetModal = () => {
    this.setState({ isForgottenPasswordResetModalOpen: false });
  };

  handleDismissPasswordResetModal = () => {
    this.setState({ isPasswordResetModalOpen: false });
  };

  handleDismissPasswordResetRequestModal = () => {
    this.setState({ isPasswordResetRequestModalOpen: false });
  };

  handleSummonChangeUsernameModal = () => {
    this.setState({ isChangeUsernameModalOpen: true });
  };

  handleSummonDeactivateAccountModal = () => {
    this.setState({ isDeactivateAccountModalOpen: true });
  };

  handleSummonPasswordResetModal = () => {
    this.setState({ isPasswordResetModalOpen: true });
  };

  handleSummonPasswordResetRequestModal = () => {
    this.setState({ isPasswordResetRequestModalOpen: true });
  };

  handleLogout = () => {
    const { dispatch, history } = this.props;
    dispatch(logoutUser(history));
  };

  /**
   * Render
   * @return {JSX}
   */
  render() {
    const {
      isFetching,
      data,
    } = this.props;

    const {
      hash,
      isChangeUsernameModalOpen,
      isForgottenPasswordResetModalOpen,
      isDeactivateAccountModalOpen,
      isPasswordResetModalOpen,
      isPasswordResetRequestModalOpen,
      token,
    } = this.state;

    if (isFetching) {
      return (
        <div style={{ padding: 24 }}>
          <Loading spinner />
        </div>
      );
    }

    return (
      <Fragment>
        {data && (
          <AccountComponent
            data={data}
            hash={hash}
            onLogout={this.handleLogout}
            onSummonDeactivateAccountModal={this.handleSummonDeactivateAccountModal}
            onSummonPasswordResetRequestModal={this.handleSummonPasswordResetRequestModal}
            onSummonChangeUsernameModal={this.handleSummonChangeUsernameModal}
          />
        )}

        <ChangeUsernameModal
          isOpen={isChangeUsernameModalOpen}
          onRequestClose={this.handleDismissChangeUsernameModal}
        />

        <DeactivateAccountModal
          isOpen={isDeactivateAccountModalOpen}
          onRequestClose={this.handleDismissDeactivateAccountModal}
        />

        <ForgottenPasswordResetModal
          isOpen={isForgottenPasswordResetModalOpen}
          onRequestClose={this.handleDismissForgottenPasswordResetModal}
          token={token}
        />

        <PasswordResetModal
          isOpen={isPasswordResetModalOpen}
          onRequestClose={this.handleDismissPasswordResetModal}
          token={token}
        />

        <PasswordResetRequestModal
          isOpen={isPasswordResetRequestModalOpen}
          onRequestClose={this.handleDismissPasswordResetRequestModal}
        />

      </Fragment>

    );
  }
}

AccountContainer.displayName = 'AccountContainer';

const mapStateToProps = ({ contacts, settings, user }) => ({
  ...settings,
  user,
  message: settings.message || contacts.message,
});

export default withRouter(connect(mapStateToProps)(AccountContainer));
